import debounce from 'lodash/debounce';
import swal from 'sweetalert2';
import {VTooltip} from 'v-tooltip';
import Vue from 'vue';
import ActionModal from '../components/ActionModal';
import ProgressBar from '../components/ProgressBar';
import SimpleModal from '../components/SimpleModal';
import Step from '../components/Step';
import {getCampaignState} from '../utility/api/campaign/getCampaignState';
import {unlockCampaign} from '../utility/api/campaign/unlockCampaign';
import {updateCampaign} from '../utility/api/campaign/updateCampaign';
import {getUserProfile} from '../utility/api/user/getUserProfile';
import {getAllEmailDomains} from '../utility/api/vessel/getAllEmailDomains';
import {generateAndDownloadComplianceDocument} from '../utility/campaign/compliance/generateAndDownloadComplianceDocument';
import {submitComplianceDocument} from '../utility/api/campaign/compliance/submitComplianceDocument';
import {isComplianceDocumentReadyForDownload} from '../utility/api/campaign/compliance/isComplianceDocumentReadyForDownload';
import {confirmationHelper} from '../utility/confirmationHelper';
import {convertServerDateToLocalMoment} from '../utility/date/date-converter';
import {delay} from "../utility/delay";
import * as Sentry from "@sentry/vue";

Vue.component('timeline-view', {
  data() {
    return {
      campaign: JSON.parse(this.vueCampaign),
      steps: JSON.parse(this.vueSteps),
      user: JSON.parse(this.vueUser),
      percentageCompleted: '0%',
      complianceDocLoading: false,
      launchDate: null,
      piecesToEdit: null,
      me: null,
      meta: {
        steps: {
          completed: [],
          disabled: [],
          required: [],
        },
      },
      noVerifiedDomains: false,
    };
  },
  methods: {
    moment(date) {
      return moment(date);
    },
    date(date) {
      return moment(date).format('MMMM Do, YYYY');
    },
    btoa(str) {
      return btoa(str);
    },
    async initSteps() {
      let els = document.getElementsByClassName('step-completed-container');

      for (let i = 0; i < els.length; i++) {
        els[i].classList.add('animated', 'bounceIn');
      }

      for (let i = 0; i < this.steps.length; i++) {
        if (this.steps[i].status === false) {
          this.meta.steps.disabled.push(this.steps[i].id);
        }
      }

      for (let i = 0; i < this.steps.length; i++) {
        if (this.steps[i].edit_status !== 'required') {
          this.stepCompleted(this.steps[i].id);
        }
      }

      this.updateCampaignState();
    },
    updateEditStatusTooltipControl(stepId) {
      this.steps.map(function(step) {
        if (step.id === stepId) {
          step.edit_status_tooltip_control = 'saved';
        }
        return step;
      });
    },
    stepCompleted(stepId) {
      if (!this.meta.steps.completed.includes(stepId) && !this.meta.steps.disabled.includes(stepId)) {
        this.meta.steps.completed.push(stepId);
        this.percentage_completed_number = Math.ceil(
          (this.meta.steps.completed.length / (this.steps.length - this.meta.steps.disabled.length)) * 100
        );
        this.percentage_completed =
          this.percentage_completed_number < 101 ? this.percentage_completed_number + '%' : '100%';
        document.getElementById('progress-bar').style.width = this.percentage_completed;
        document.getElementById('progress-bar-meta').innerHTML = this.percentage_completed;
      }

      let el = document.getElementsByClassName('step-' + stepId)[0];
      el.style.animationDelay = '0.5s';
      el.style.animationDuration = '1s';
      el.style.visibility = 'visible';

      setTimeout(() => {
        el = document.getElementsByClassName('step-' + stepId)[0];
        el.style.transition = 'border-color 1s';
        el.style.borderTopColor = colorCta;
      }, 500);

      setTimeout(() => {
        el = document.getElementsByClassName('step-enabled-' + stepId)[0];

        el.style.transition = '';
        el.style.visibility = 'visible';
      }, 1500);

      this.prepareForLaunch();
    },
    updateCampaignState() {
      getCampaignState(this.campaign.id).then(stateData => {
        if (stateData.state) {
          this.campaign.state = stateData.state;
          this.campaign.can_be_launched = stateData.can_be_launched;
        }
      });
    },
    prepareForLaunch() {
      if (this.meta.steps.completed.length >= this.steps.length - this.meta.steps.disabled.length) {
        document.getElementById('getready').style.display = 'none';

        const prepareForLaunchElement = document.getElementById('prepareforlaunch');
        prepareForLaunchElement.style.display = 'block';
        prepareForLaunchElement.style.visibility = 'visible';
        prepareForLaunchElement.classList.add('animated', 'fadeIn');
      }
    },
    onCampaignNameBlur(event) {
      const campaignName = event.target.textContent.trim();
      if (campaignName !== this.campaign.name) {
        this.saveCampaignName(this.campaign, campaignName);
      }
    },
    saveCampaignName: debounce((campaign, name) => {
      updateCampaign(campaign.id, {name})
        .then(() => {
          campaign.name = name;
          $.notify('Saved Campaign Name', 'success');
        })
        .catch(error => {
          let text = 'We had a problem saving the campaign name.';

          const {data} = error.response || {};
          if (data && data.errors && data.errors.name) {
            text = data.errors.name[0];
          }

          $.notify(text, {autoHide: false, position: 'left middle'});
        });
    }, 2000),
    confirmGeneratingComplianceDocument() {
      swal
        .fire({
          title: 'Are you sure you want to lock this campaign and submit it to compliance?',
          text:
            'You will NOT be able to edit once submitted. Please ensure you send the most recently downloaded PDF version for review.',
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: colorCta,
          confirmButtonText: 'Yes',
        })
        .then(result => {
          if (result.value) {
            this.downloadComplianceDocument();
          }
        });
    },
    confirmSubmitForCompliance() {
      swal
          .fire({
            title: 'Are you sure you want to lock this campaign and submit it to compliance?',
            text:
                'You will NOT be able to edit once submitted.',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: colorCta,
            confirmButtonText: 'Yes',
          })
          .then(result => {
            if (result.value) {
              this.submitForCompliance();
            }
          });
    },
    async submitForCompliance() {
      if (this.campaign.campaignApprovalVersion === 2 && this.campaign.state == 'changed') {
        this.campaign.state = 'locked';
      }

      this.complianceDocLoading = true;
      this.campaign.state = 'locked';

      try {
        this.campaign.can_be_unlocked = false;
        await submitComplianceDocument(this.campaign.id);
        await this.waitForComplianceDoc();
      } catch (error) {
        this.showErrorMessage(error.message);
      }

      this.complianceDocLoading = false;
    },
    async downloadComplianceDocument(shouldGenerate = true, shouldNotIgnoreOutdated = true) {
      if (this.campaign.lockChangedCampaigns && this.campaign.state == 'changed') {
        this.campaign.state = 'locked';
      }

      if (this.complianceDocLoading) {
        $.notify('Compliance document is already being downloaded.', 'warning');
        return;
      }

      this.complianceDocLoading = true;

      try {
        await generateAndDownloadComplianceDocument(this.campaign.id, false, shouldGenerate, shouldNotIgnoreOutdated);
      } catch (error) {
        this.showErrorMessage(error.message);
      }

      this.complianceDocLoading = false;
    },
    async onCopyComplianceDocumentLink() {
      const url = `${window.location.origin}/compliance-doc?sk_token=${campaign.complianceDocToken}`;
      await window.navigator.clipboard.writeText(url);
      $.notify('Link has been copied', 'success');
    },
    updateDate(date) {
      this.launchDate = date;
    },
    onHistoryChange() {
      const searchParams = new URLSearchParams(window.location.search.slice(1));
      if (!searchParams.has('modal')) {
        this.closeModal();
      } else {
        this.openModal(searchParams);
      }
    },
    closeModal() {
      this.$refs.stepComponents.forEach(component => component.closeModals());
    },
    openModal(searchParams) {
      const modalId = atob(searchParams.get('modal'));
      this.$refs.stepComponents.forEach(component => component.openModal(modalId));
    },
    openModalFromUrl() {
      const searchParams = new URLSearchParams(window.location.search.slice(1));
      if (searchParams.has('modal')) {
        this.openModal(searchParams);
      }
    },
    async waitForComplianceDoc() {
      this.campaign.can_be_unlocked = false;
      const {status} = await isComplianceDocumentReadyForDownload(this.campaign.id, false);
      if (status !== 'generating') {
        this.campaign.can_be_unlocked = true;
        return true;
      }
      await delay(5000);
      return this.waitForComplianceDoc();
    },
    async onUnlockClick() {
      if (!this.campaign.can_be_unlocked) {
        await confirmationHelper.warning(
            'Unlocking is disabled until the compliance PDF is generated',
            'Unlocking currently disabled',
            'OK',
            false
        );
        this.complianceDocLoading = true;
        await this.waitForComplianceDoc();
        this.complianceDocLoading = false;
        return;
      }

      const text =
        'Unlocking this campaign will require that you download a new compliance PDF for compliance submission.';
      const confirmed = await confirmationHelper.warning(text);

      if (!confirmed) {
        return;
      }

      try {
        await unlockCampaign(this.campaign.id);
        swal.fire({title: 'Sweet!', text: 'Campaign has been unlocked.', type: 'success'});
        window.location.reload();
      } catch (error) {
        Sentry.captureException(error);
        this.showErrorMessage('We had a problem unlocking the campaign.');
      }
    },
    showErrorMessage(text) {
      swal.fire({
        title: 'Uh Oh!',
        text,
        type: 'error',
        confirmButtonText: 'Ok',
        buttonsStyling: false,
        confirmButtonClass: 'btn btn-lg btn-primary',
      });
    },
    async checkVerifiedDomains() {
      const domains = await getAllEmailDomains();
      this.noVerifiedDomains = !(domains || []).some(domain => domain.verified);
    },
  },
  computed: {
    campaignLocked() {
      return this.campaign && this.campaign.lockChangedCampaigns && this.campaign.state == 'locked';
    },
    resumeDate() {
      return this.campaign.can_be_resumed
        ? convertServerDateToLocalMoment(this.campaign.resume_date, 'YYYY-MM-DD HH:mm:ss', this.timezone)
              .format('MM/DD/YYYY HH:mm')
        : null
    }
  },
  filters: {
    moment(date) {
      return moment(date).format('MMMM Do YYYY, h:mm:ss a');
    },
  },
  components: {Step, ActionModal, SimpleModal, ProgressBar, VTooltip},
  props: ['vueCampaign', 'vesselId', 'vueSteps', 'vueUser', 'timezone'],
  async created() {
    this.me = await getUserProfile();
  },
  mounted() {
    this.initSteps();
    window.onpopstate = () => this.onHistoryChange();
    this.openModalFromUrl();
    this.checkVerifiedDomains();
    this.waitForComplianceDoc();
  },
});
